<template>
  <div class="container">
    <div class="row d-flex pt-3 pb-3 mb-5">
      <div class="col-6">
        <img src="../../assets/image/403.png" alt="403" />
      </div>
      <div
        class="
          col-6
          flex-column
          d-flex
          justify-content-center
          align-items-center
        "
      >
        <h1 class="text-secondary fw-bolder fs-64">{{ $t("403") }}</h1>
        <h2 class="text-secondary fw-semibold fs-32">{{ $t("forbidden") }}</h2>
        <p class="text-secondary fs-16">{{ $t("forbiddenDetail") }}</p>
        <a
          href="/dashboard/company-overview"
          class="
            ag-button
            btn-sm
            d-inline-flex
            align-items-center
            ag-button_primary
          "
        >
          Back to Home Page
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { JL } from "jsnlog";
import { useStore } from "@/store";

const store = useStore();

export default {
  mounted() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV !== "development") {
      JL.setOptions({
        defaultAjaxUrl: `${process.env.VUE_APP_AGSC_API}logging`,
      });
      const errorData = {
        email: store.getters.loggedInUser
          ? store.getters.loggedInUser.email
          : "",
        exception: "403 Forbidden",
        endpoint: window.location.pathname,
        browser: window.navigator.userAgent,
      };
      JL().error(errorData);
    }
  },
};
</script>

<style scoped>
.fs-64 {
  font-size: 4rem;
}
.fs-16 {
  font-size: 1rem;
}
.fs-32 {
  font-size: 2rem;
}
</style>